import { useCallback, useEffect, useState } from 'react'
import { Voice } from '@web-lite/voice-recorder/build/main/lib/types'
import { Recorder } from './recorder'
import { VoicePreview } from './voice-preview'
import { RecorderStatus } from '../../send-field.type'

interface Props {
  recorderState: RecorderStatus
  sendVoice: (voice: Voice) => unknown
  setRecorderState: (state: RecorderStatus) => unknown
}
export function VoiceRecorder({
  recorderState,
  sendVoice,
  setRecorderState,
}: Props) {
  const [recorderVoice, setRecorderVoice] = useState<Voice>()

  const recording =
    recorderState === 'PRESSED' ||
    recorderState === 'RECORD' ||
    recorderState === 'WAITING'

  const sendRecordedVoice = useCallback(() => {
    if (!recorderVoice) return
    sendVoice(recorderVoice)
  }, [sendVoice, recorderVoice])

  useEffect(() => {
    if (recorderState === 'IDLE') setRecorderVoice(undefined)
  }, [recorderState])

  return (
    <>
      {recording && (
        <Recorder
          state={recorderState}
          setRecorderState={setRecorderState}
          setRecorderVoice={setRecorderVoice}
        />
      )}
      {recorderState === 'PLAYING' && recorderVoice && (
        <VoicePreview
          duration={recorderVoice.duration}
          onReset={() => setRecorderState('IDLE')}
          onSend={sendRecordedVoice}
        />
      )}
    </>
  )
}
